module.exports = __webpack_public_path__ + "static/media/HB_buddhabowl_forweb1_edited.a6168c91.jpg";